import React from "react";
import Metodology from "../components/metodology/Metodology";
import MainLayout from "../components/layout/MainLayout";

const MetodologyPage = () => {
  return (
    <MainLayout>
      <Metodology />
    </MainLayout>
  );
};

export default MetodologyPage;
